import useSWR from "swr";
import {Utils} from "../common/utils";
const clientConfigs = Utils.getEAIClientConfigs();

export interface CourseBasic {
    id: number
    name: string
    school_id: string
    total_count: number
}

export interface CoursesResponse {
    data: CourseBasic[]
}

export function useCourses() {
    const {data, error, mutate} = useSWR<CoursesResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/courses/?fields=basic`);

    return {
        data,
        error,
        mutate
    };
}